import React, { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';
import ManageProgress from './manageProgress';
import ManageButton from './manageButton';



const B_Manage = (props) => {
    const dispatch = useDispatch();

    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakingEarnedAmount = useSelector((state) => state.mainapp.stakingSlice.earnings)
    const stakedAt = useSelector((state) => state.mainapp.stakingSlice.stakingTime)
    const userIndex = useSelector((state) => state.mainapp.stakingSlice.userIndex)




    return (
        <>
            <div className='manage-container'>
                <ManageProgress />
                <div className='vert-separator'></div>
                <ManageButton />
            </div>
        </>
    );
};

export default B_Manage
